import { render, staticRenderFns } from "./DescriptionTextArea.vue?vue&type=template&id=3b9c32c0&scoped=true&"
import script from "./DescriptionTextArea.vue?vue&type=script&lang=js&"
export * from "./DescriptionTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9c32c0",
  null
  
)

export default component.exports